import type { WorkOrder } from '@ztechapps/common.contract'
import type { UseLazyListResult } from '@ztechapps/common.hook'
import { useLazyList } from '@ztechapps/common.hook'
import { workOrderChildrenListQuery } from './graphql'

export const useWorkOrderChildrenList = (): UseLazyListResult<WorkOrder> => {
  return useLazyList<WorkOrder>({
    query: workOrderChildrenListQuery,
    entity: 'workOrderChildrenList',
    options: {
      queryOptions: {
        fetchPolicy: 'cache-and-network',
      },
    },
  })
}
